export default "__VITE_ASSET__Cu83zVwW__"